import type { Column } from '@/components/Organisms/DataTable/DataTable.types';
import { colors } from '@/components/ui/theme';
import type { UserSessionStatus } from '@/types/users';

/**
 * User Status mapping with colors
 */
const STATUS_MAP: Record<string, { label: string; color: string }> = {
	true: { label: 'Enabled', color: colors.primary },
	false: { label: 'Disabled', color: colors.defaultGray },
};

/**
 * Maps User status boolean to status object with label and color
 * @param status - The status boolean from data
 * @returns Object with label and color, or default values
 */
export const getUserStatus = (
	status: boolean,
): { label: string; color: string } => {
	return (
		STATUS_MAP[String(status)] || { label: '-', color: colors.defaultGray }
	);
};

const SESSION_STATUS_MAP: Record<
	UserSessionStatus,
	{ label: string; color: string }
> = {
	online: { label: 'Online', color: colors.success },
	away: { label: 'Away', color: colors.statusOrange },
	loggedOut: { label: 'Logged Out', color: colors.defaultGray },
};

export const getUserPresenceStatus = (
	status?: UserSessionStatus,
): { label: string; color: string } => {
	return SESSION_STATUS_MAP[status || 'loggedOut'];
};

// Status filter options
export const dropdownFilterOptions = [
	{ label: 'Admin', value: 'admin' },
	{ label: 'Manager', value: 'manager' },
	{ label: 'Accounting', value: 'accounting' },
	{ label: 'Rep', value: 'rep' },
];

export const statusesFilterOptions = [
	{ label: 'Enabled', value: 'enabled' },
	{ label: 'Disabled', value: 'disabled' },
];

export const sessionStatusesFilterOptions = [
	{ label: 'Login', value: 'login' },
	{ label: 'Away', value: 'away' },
	{ label: 'Logged Out', value: 'loggedOut' },
];

export const columns: Column[] = [
	{
		key: 'username',
		label: 'Username',
		width: '180px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'email',
		label: 'Email',
		width: '220px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'role',
		label: 'Role',
		width: '150px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'lastAccess',
		label: 'Last Active',
		width: '150px',
		type: 'date',
		dateISO: true,
		sorter: true,
	},
	{
		key: 'sessionStatus',
		label: 'Session Status',
		width: '140px',
		type: 'string-status',
		filterOptions: sessionStatusesFilterOptions,
	},
	{
		key: 'portsAvailable',
		label: 'Port',
		width: '120px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'createdAt',
		label: 'Creation Date',
		width: '150px',
		type: 'date',
		dateISO: true,
		sorter: true,
	},
	{
		key: 'status',
		label: 'Status',
		width: '120px',
		type: 'string-status',
		filterOptions: statusesFilterOptions,
	},
];
